import { render } from "./SearchResultContact.vue?vue&type=template&id=5ca7a842"
import script from "./SearchResultContact.vue?vue&type=script&lang=js"
export * from "./SearchResultContact.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__